<script>
import formatCurrency from "@utils/format-currency";
import formatPaymentMethod from "@utils/format-payment-method";
import  { formatOrder } from "@utils/format-order";
import { authComputed, merchantComputed } from "@store/helpers";
import formatPrice from "@utils/format-price";
import { conditionList } from "@utils/is-condition";
import { 
  orderAtmInfoList, 
  orderIsCanPay,
  // orderIsOffline,
  orderIsUseDeduct,
  orderVaccInfoList,
  orderIsPrepaidUnpaidAndDeduct,
  orderBillingReserveList,
  orderReserveParamsList,
} from "@utils/ipetbooking-order";

export default {
  components: {
    ChildrenItem: () =>  import("@components/Order/components/OrderReservationChildrenItem"),
    OrderPaymentButton: () => import("@components/Order/OrderPaymentButton"),
  },
  props: {
    containerItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isSingle: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'all',
      validator(value) {
        return [
          'unPaidMain',
          'all',
          'children'
        ].includes(value)
      },
    }
  },
  data() {
    return {
      // activeTab: 'detail',
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    hasExtrafieldsByOrder() {
      const orderExtrafields = this.containerItem.byOrderExtrafields || {};

      return !!Object.keys(orderExtrafields)[0];
    },
    hasExtrafields() {
      return this.hasExtrafieldsByOrder
    },
    // isOffline() {
    //   return orderIsOffline({
    //     order: this.containerItem,
    //     ordertype: 'order',
    //     type: 'reservation'
    //   });
    // },
    isUseDeduct() {
      return orderIsUseDeduct({ ...this.containerItem })
    },
    isUnpaidAndDeduct() {
      return orderIsPrepaidUnpaidAndDeduct({ ...this.containerItem })
    },
    priceTotal() {
      const ordersListTotal = this.containerItem.orders.items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.priceTotal
      }, 0);
      const paramsListTotal = this.containerItem.params.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.total
      }, 0);
      return ordersListTotal + paramsListTotal
    },
    orderBillingParamsList() {
      const paramsList = (typeList) => {
        return orderReserveParamsList({
          typeList,
          params: this.containerItem.params,
        });
      };
      const total = this.containerItem.orders.items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.priceTotal
      }, 0);
      return conditionList([
        {
          title: '小計',
          text: `${formatPrice(total)}`,
          textClass: 'font-number',
        },
        {
          type: 'hr',
          condition: () => {
            return !!paramsList(['+', '-', '%'])[0]
          },
        },
        ...paramsList(['+', '-', '%']),
      ])
    },
    orderBillingTotal() {
      const orderStatus = formatOrder(this.containerItem)
      return conditionList([
        {
          title: `<span class="text-${orderStatus.color} fw-semi-bold">${orderStatus.title}</span><br><span class="text-gray-2 fs-2sm">${orderStatus.paidInfo}</span>`,
          text: `${formatPrice(this.priceTotal)}`,
          class: 'align-items-end mt-2',
          textClass: `font-number fs-xl fw-semi-bold text-${orderStatus.infoColor}`,
          // condition: () => {
          //   return type === 'order'
          // },
        }
      ])
    },
    vaccInfoList() {
      return orderVaccInfoList({ ...this.containerItem, unpaid: this.priceTotal })
    },
    atmInfoList() {
      return orderAtmInfoList({ ...this.containerItem, unpaid: this.priceTotal })
    },
  },
  created() {
    if(this.$route.query.activeTab) {
      this.activeTab = this.$route.query.activeTab
    }
  },
  methods: {
    formatCurrency,
    formatPaymentMethod,
    orderIsCanPay,
    formatPrice,
    orderBillingList(item) {
      return orderBillingReserveList({
        type: 'order',
        ...item,
        isUnpaidAndDeduct: this.isUnpaidAndDeduct,
        formatOrder: formatOrder(item)
      });
    },
    goToMemberReservationItem(containerItem) {
      const loggedInFn = () => {
        this.$nextTick(() => {
          this.$router.push({
            name: 'member-reservation-item',
            params: {
              orderId: containerItem.id
            }
          })
        })
      };

      if(this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          }
        })
      }
    },
    goToMemberReservationItemChildren(containerItem) {
      const loggedInFn = () => {
        this.$nextTick(() => {
          this.$router.push({
            name: 'member-reservation-item',
            params: {
              orderId: containerItem.parentId
            },
            query: {
              activeTab: 'children'
            }
          })
        });
      };

      if(this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          }
        })
      }
    },
    openDialogContact(item) {
      this.$globalDialog('DialogContact', {
        storeList: [item.param.store]
      });
    },
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.orderReservationChildrenList">
    <template v-if="!isSingle && type !== 'unPaidMain'">
      
      <div v-for="(childrenItem ) in containerItem.childrenContainers.items"
      :key="childrenItem.uuid"
      class="orderReservationChildrenList__item"
      >
        <ChildrenItem :children-item="childrenItem"  :is-collapse="containerItem.childrenContainers.items.length > 1" />
        <OrderPaymentButton
          :order-item="childrenItem"
          type="reservation"
          button-class="mt-5 px-4"
        />
      </div>
    </template>
    <template v-else-if="!isSingle && type === 'unPaidMain'">
      <div v-for="(item ) in containerItem"
      :key="item.uuid"
      class="orderReservationChildrenList__item"
      >
        <ChildrenItem :children-item="item"  :is-collapse="item.length > 1" />
        <OrderPaymentButton
          :order-item="item"
          type="reservation"
          button-class="mt-5 px-4"
        />
      </div>
    </template>
    <template v-else>
      <ChildrenItem :children-item="containerItem" />
      <OrderPaymentButton
        :order-item="containerItem"
        type="reservation"
        button-class="mt-5 px-4"
      />
    </template>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.orderReservationChildrenList {
  // padding: 1.875rem;
  // border: 1px solid rgba($color-primary, 0.5);

  @include max-md {
    padding: 1rem;
  }

  :global {
    .orderReservationChildrenList {
      // &__no {
      //   padding: 1rem;
      //   margin-bottom: 2rem;
      //   font-size: 0.875rem;
      //   background: rgba($color-line, 0.3);
      //   // border: 1px solid $color-primary;
      // }
      &__list {
        &:not(:last-child) {
          margin-bottom: 1.875rem;
        }
      }
      &__hr {
        width: 100%;
        border-top: 1px dashed $color-line;
      }
      &__detailBoxInner {
        padding: 1.5rem 1rem 0;
        display: flex;
        @include max-md {
          display: block;
        }

        &:not(:last-child) {
          border-bottom: 1px solid $color-line;
        }
      }
      &__item {
        border: 1px solid rgba($color-primary, 0.5);
        padding-bottom: 1.875rem;
        &:not(:last-child) {
          margin-bottom: 1.875rem;
        }
      }
      &__btn {
        &:not(:last-child) {
          margin-right: 1rem;
        }
      }
    }
  }
}
</style>
